import validators from '@utils/validators';

const validate = (values) => {
    const errors = {};

    Object.assign(errors, validators.required(values.name, 'name'));
    Object.assign(errors, validators.required(values.url, 'url'));
    Object.assign(errors, validators.maxLength({value: values.name, maxLength: 50}, 'name'));
    Object.assign(errors, validators.maxLength({value: values.description, maxLength: 200}, 'description'));
    Object.assign(errors, validators.maxLength({value: values.url, maxLength: 500}, 'url'));
    Object.assign(errors, validators.url(values.url, 'url', undefined, 'srt'));
    Object.assign(errors, validators.urlOptional(values.preview_url, 'preview_url', undefined, '.+'));
    Object.assign(errors, validators.maxLength({value: values.previewUrl, maxLength: 500}, 'url'));

    if (values.has_scte35) {
        Object.assign(errors, validators.required(values.ad_splice_config, 'ad_splice_config'));
    }

    return errors;
};

export default validate;
